/**
 * Alert category metadata for filters and labels.
 *
 * Note: Sample alert seeding removed. Real alerts generated by detection engines only.
 */

export type CategoryKey = 'email' | 'dark_web' | 'device';

export const CATEGORY_OPTIONS: { key: CategoryKey; label: string }[] = [
  { key: 'email', label: 'Email Threats' },
  { key: 'dark_web', label: 'Dark Web' },
  { key: 'device', label: 'Device' },
];

export function categoryLabel(cat: string): string {
  const found = CATEGORY_OPTIONS.find((c) => c.key === cat);
  return found?.label ?? cat;
}
